import { percent } from "../analytics";
import { downloadCsv } from "./DataTable";

export interface ShareRow {
  key: string;
  label: string;
  value: number;
  /** 0–1 (null: no total to share). */
  share: number | null;
}

/**
 * A split of one day's counts (DESIGN.md decision 9): label, count and a
 * share meter (the percent is written beside it, never the bar alone), with
 * the same numbers as a CSV.
 */
export function ShareTable({
  title,
  note,
  header,
  rows,
  fileName,
}: {
  title: string;
  note?: string;
  header: readonly [string, string];
  rows: readonly ShareRow[];
  fileName: string;
}) {
  return (
    <figure className="chart">
      <figcaption>
        {title} {note && <span className="muted">· {note}</span>}
      </figcaption>
      {rows.length === 0 ? (
        <p className="muted">Nothing counted yet.</p>
      ) : (
        <table>
          <thead>
            <tr>
              <th>{header[0]}</th>
              <th className="num">{header[1]}</th>
              <th>Share</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr key={row.key}>
                <td>{row.label}</td>
                <td className="num">{row.value.toLocaleString()}</td>
                <td>
                  <span className="meter" aria-hidden="true">
                    <span style={{ width: `${(row.share ?? 0) * 100}%` }} />
                  </span>{" "}
                  {percent(row.share)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      {rows.length > 0 && (
        <p>
          <button
            type="button"
            className="button-quiet"
            onClick={() =>
              downloadCsv(
                fileName,
                [header[0], header[1], "Share (%)"],
                rows.map((row) => [
                  row.label,
                  row.value,
                  row.share === null ? null : Math.round(row.share * 1000) / 10,
                ]),
              )
            }
          >
            Download CSV
          </button>
        </p>
      )}
    </figure>
  );
}
